(() => {
function init() {
  const openers = document.querySelectorAll(".wh-header [data-open]");
  openers.forEach(button => {
    if (button.dataset.whBound) return;
    button.dataset.whBound = "true";
    button.addEventListener("click", () => {
      const dialog = document.getElementById(button.dataset.open);
      if (!dialog) return;
      dialog.showModal();
      const focusTarget = dialog.querySelector('input[type="search"]') || dialog.querySelector("[data-close]");
      focusTarget?.focus();
    });
  });
  document.querySelectorAll(".wh-dialog").forEach(dialog => {
    if(dialog.dataset.whBound)return;dialog.dataset.whBound="true";
    dialog.querySelector("[data-close]")?.addEventListener("click", () => dialog.close());
    dialog.addEventListener("keydown", event => {
      if (event.key === "Escape") {
        event.preventDefault();
        dialog.close();
      }
    });
    dialog.addEventListener("click", event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });
}
init(); document.addEventListener("shopify:section:load", init);
})();

(() => {
function enhance(){
 const tabs=[...document.querySelectorAll('[data-wh-filter]')];
 const cards=[...document.querySelectorAll('.wh-product[data-category]')];
 function choose(tab,focus){
  const selected=tab.dataset.whFilter;
  tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1});
  cards.forEach(c=>c.hidden=selected!=='all'&&c.dataset.category!==selected);
  const panel=document.getElementById('wh-products-panel');if(panel)panel.setAttribute('aria-labelledby',tab.id);
  const status=document.querySelector('.wh-filter-status');if(status)status.textContent=cards.filter(c=>!c.hidden).length+' featured products';
  const empty=document.querySelector('.wh-empty-category');if(empty)empty.hidden=cards.some(c=>!c.hidden);
  if(focus){tab.focus();tab.scrollIntoView({block:'nearest',inline:'nearest'})}
 }
 tabs.forEach((tab,i)=>{if(tab.dataset.filterBound)return;tab.dataset.filterBound='1';tab.addEventListener('click',()=>choose(tab,false));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();choose(tabs[n],true)}})});
 if(tabs.length)choose(tabs.find(t=>t.getAttribute('aria-selected')==='true')||tabs[0],false);
 document.querySelectorAll('.wh-newsletter-form').forEach(form=>{
  if(form.dataset.signupBound)return;form.dataset.signupBound='1';
  form.addEventListener('submit',async e=>{
   if(e.defaultPrevented||!form.reportValidity())return;
   e.preventDefault();
   const button=form.querySelector('button[type=submit]'),status=form.querySelector('.wh-email-status');
   const error=form.querySelector('[data-email-error]').textContent;
   button.disabled=true;status.textContent='Submitting…';
   try{
    const response=await fetch(form.action,{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{'Accept':'text/html'}});
    const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
    const success=parsed.querySelector('[data-newsletter-success="true"]');
    const errors=parsed.querySelector('.wh-email-status .errors');
    if(response.ok&&success){status.textContent=success.textContent.trim();status.dataset.newsletterSuccess='true';form.querySelector('.wh-email-row').hidden=true}
    else{delete status.dataset.newsletterSuccess;status.textContent=errors?.textContent?.trim()||error}
   }catch{status.textContent=error}finally{button.disabled=false}
  });
 });
}
enhance();document.addEventListener('shopify:section:load',enhance);
})();
(() => {
 document.addEventListener('click', e => {document.querySelectorAll('.wh-dropdown[open]').forEach(d=>{if(!d.parentElement.contains(e.target))d.open=false})});
 document.addEventListener('keydown', e => {if(e.key==='Escape')document.querySelectorAll('.wh-dropdown[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});
 const count=document.querySelector('.wh-cart-count');
 if(count){const update=()=>{count.hidden=Number(count.textContent.trim())===0;count.closest('a').setAttribute('aria-label','View shopping cart ('+count.textContent.trim()+')')};new MutationObserver(update).observe(count,{childList:true,characterData:true,subtree:true});update()}
})();
